import { Component, ChangeDetectorRef, inject, signal } from '@angular/core';
import { DocMeta } from "../../../../decorators";
import { MatButton } from "@angular/material/button";
import { UiLibraryModule } from "../../../../template-ui.module";
import { CommonModule } from "@angular/common";
import { ButtonModule } from "primeng/button";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { FormsModule } from '@angular/forms';
//import { MessageService } from 'primeng/api';
import { Toast } from "primeng/toast";
import { EzBaseComponent } from "../../../ez-base.component";
import { EzMessageService } from "../../../../services/message.service";
import { MessageService, ToastMessageOptions } from "primeng/api";

@DocMeta({
  hide: true,
  showcaseTitle: "Compare Buttons",
  showcaseDesc: `
  This sample demonstrates some legacy buttons compared to several EZ Button variants using just HTML (no config).
  `
})
@Component({
    selector: 'ui-compare-buttons, ez-compare-buttons',
    imports: [
        CommonModule,
        FormsModule, // <-- Needed for toggle switch
        // Material
        MatButton,
        // PrimeNg
        ButtonModule,
        ToggleSwitchModule,
        //InputSwitchModule, // <-- Add here
        UiLibraryModule,
        Toast
    ],
    templateUrl: './compare-buttons.component.html',
    styleUrl: './compare-buttons.component.scss'
})
export class CompareButtonsComponent extends EzBaseComponent {

  ezMsg = inject(EzMessageService);
  pngMessageService = inject(MessageService);

  outputs: string[] = Array(12).fill('');
  clickCounts: number[] = Array(12).fill(0);
  disabled = false;

  // Signal for badge value
  badgeValue = signal(0);

  flashMessages: string[] = Array(8).fill('');
  private flashTimeouts: (number | undefined)[] = Array(8).fill(null);

  constructor(
    private cdr: ChangeDetectorRef,
    //private messageService: MessageService
  ) {
    super();
    this.thisClassName = 'CompareButtonsComponent';
  }


  onButtonClick(index: number, label: string) {
    this.clickCounts[index]++;
    this.outputs[index] = `${label} clicked ${this.clickCounts[index]} time${this.clickCounts[index] === 1 ? '' : 's'}!`;

    // Increment badgeValue if secondary button is clicked (index 11)
    if (index === 11) {
      this.badgeValue.update(v => v + 1);
    }

    // Flash message logic for each button
    this.flashMessages[index] = `${label} was clicked!`;
    this.cdr.markForCheck();
    if (this.flashTimeouts[index]) {
      clearTimeout(this.flashTimeouts[index]);
    }
    this.flashTimeouts[index] = window.setTimeout(() => {
      this.flashMessages[index] = '';
      this.cdr.markForCheck();
    }, 1000) as number;

    // Clear previous messages
    this.pngMessageService.clear();

    this.pngMessageService.add({
      key: 'button-toast',
      severity: 'info'
      , summary: 'Button Clicked'
      , detail: `${label} was clicked!`
      , life: 150000
    } as ToastMessageOptions);


    // Show p-toast message with correct key
    // this.ezMsg.add({
    //   key: 'button-toast', // <-- Make sure this matches your <p-toast>
    //   severity: 'info',
    //   summary: 'Button Clicked',
    //   detail: `${label} was clicked!`,
    //   life: 1000
    // });
  }
}
